module.exports = __webpack_public_path__ + "static/4-7108f434044832b238d5165787d8bb74.jpg";